import {
  FormControl,
  FormHelperText,
  MenuItem,
  Select as MaterialSelect,
  InputLabel,
} from "@mui/material";
import { MultiSelectProps } from "./types";
import { useMultiSelect } from "./useMultiSelect";

const MultiSelect = ({
  data = [],
  label,
  initialValues = [],
  allValues = { label: "Todos", value: "all" },
  onChangeCallback,
  fullWidth,
  helperText,
  required,
  ...props
}: MultiSelectProps) => {
  const { displayValue, selectedItems, handleClick } = useMultiSelect({
    data,
    initialValues,
    allValues,
    onChangeCallback,
  });

  return (
    <FormControl
      disabled={props.disabled}
      fullWidth={fullWidth}
      required={required}
    >
      {label && <InputLabel>{label}</InputLabel>}
      <MaterialSelect
        multiple
        label={label}
        value={selectedItems.length === 0 ? [allValues.value] : selectedItems}
        renderValue={() => displayValue ?? allValues.label}
        MenuProps={{
          slotProps: {
            paper: { className: `${props.className}-paper` },
          },
        }}
        {...props}
      >
        {data.length > 1 && (
          <MenuItem
            onClick={() => handleClick(allValues)}
            value={allValues.value}
            // TODO: implementar placeholder
          >
            {allValues.label}
          </MenuItem>
        )}
        {data.map((item) => (
          <MenuItem
            key={item.label}
            disabled={item.disabled}
            value={item.value}
            onClick={() => handleClick(item)}
          >
            {item.label}
          </MenuItem>
        ))}
      </MaterialSelect>
      {helperText && (
        <FormHelperText error={props.error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
};

export default MultiSelect;
